import React, { useState } from "react";
import { CustomerDropDown, TabSelector } from "@src/components/atoms";
import { useAdminContext } from "@src/context/adminContext";
import { BehavioursSection } from "../shared/BehavioursSection";
import { BehaviourTypesSection } from "../shared/BehaviourTypesSection";
import { BehaviourGroupsSection } from "../shared/BehaviourGroupsSection";
import { CustomerBehaviourGroupsSection } from "../shared/CustomerBehaviourGroupsSection";

const TABS = [
  { key: "customer", label: "Customer Behaviours" },
  { key: "customerGroups", label: "Customer Behaviour Groups" },
  { key: "types", label: "Behaviour Types" },
  { key: "groups", label: "Behaviour Groups" },
];

const BehavioursPage = () => {
  const { customers, selectedCustomer } = useAdminContext();
  const [customer, setCustomer] = useState(
    selectedCustomer
      ? selectedCustomer
      : customers.find((c) => c.customerCode === "SG"),
  );
  const [customerCode, setCustomerCode] = useState(
    selectedCustomer ? selectedCustomer.customerCode : "SG",
  );
  const [activeTab, setActiveTab] = useState("customer");

  const handleOnChange = (e) => {
    const cust = customers.find((c) => c.customerCode === e);
    setCustomerCode(e);
    setCustomer(cust);
  };

  return (
    <div className="p-2 flex flex-col gap-4">
      <h2 className="text-center p-2">Behaviours</h2>

      <TabSelector
        options={TABS}
        selected={activeTab}
        onClick={setActiveTab}
        position="start"
      />

      {activeTab === "customer" && (
        <>
          <div className="my-4">
            <CustomerDropDown onChange={handleOnChange} />
          </div>
          <BehavioursSection
            customerId={customer?.id}
            customerCode={customerCode}
            industry={customer?.industry}
          />
        </>
      )}

      {activeTab === "types" && <BehaviourTypesSection />}

      {activeTab === "groups" && <BehaviourGroupsSection />}

      {activeTab === "customerGroups" && (
        <>
          <div className="my-4">
            <CustomerDropDown onChange={handleOnChange} />
          </div>
          <CustomerBehaviourGroupsSection customerId={customer?.id} />
        </>
      )}
    </div>
  );
};

export default BehavioursPage;
